__turbopack_context__.v({
  "copy-button-wrapper": "PrettyCopyBox-module-scss-module__WSAkUa__copy-button-wrapper",
});
